export const appLinks = {
  apple: 'https://na2.hubs.ly/H07WLYt0',
  android: 'https://na2.hubs.ly/H07WLYz0',
}

/** HubSpot application form for practitioners joining the network. */
export const practitionerApplicationUrl =
  'https://share-na2.hsforms.com/2lzmKxu4mTDmTD8GYXJU8fA402mcz'

export interface AppTourStep {
  title: string
  description: string
}

export const appTourSteps: AppTourStep[] = [
  {
    title: 'Choose your path',
    description:
      'Whether you are seeking care or providing it, there is a place for you here. Start as a member or apply to join as a practitioner.',
  },
  {
    title: 'Find care that understands your needs',
    description:
      'Take the practitioner matching quiz for personalized results, or browse the full directory and filter by what matters to you.',
  },
  {
    title: 'Connect with a verified practitioner',
    description:
      'Every profile comes from a vetted, trusted network — with experience, specialties, qualifications, and rates shown up front.',
  },
  {
    title: 'Understand your health, and feel in control of it',
    description:
      'Daily mood check-ins, a personal to-do list, and journal prompts help you see a whole picture of your health over time.',
  },
  {
    title: 'From matched to booked, seamlessly',
    description:
      'Pick a time that works, confirm in a few taps, and keep virtual and in-person visits together in one calendar.',
  },
  {
    title: 'Manage your care with confidence',
    description:
      'Upcoming appointments, session details, and one-tap access to join your virtual visit — all on your home screen.',
  },
  {
    title: 'For practitioners: manage and grow your practice',
    description:
      'Your schedule, services, requests, and payments in one place, so you can spend more of your day on care.',
  },
]
